import { Skeleton, SxProps, Typography } from '@mui/material';
import React, { useEffect } from 'react';

import { useAppSelector } from '../../redux/hooks';

interface OwnProps {
  price: number;
  currencyCode: string;
  postText?: string;
  variant?: any;
  'data-cy'?: string;
  preText?: string;
  priceOnRequest?: boolean;
  sx?: SxProps;
}

const FormatCurrency: React.FC<OwnProps> = (props: OwnProps) => {
  const {
    price,
    currencyCode,
    postText,
    variant,
    'data-cy': dataCy,
    priceOnRequest = false,
    sx,
  } = props;

  const [formattedCurrency, setFormattedCurrency] = React.useState<string>('');

  const conversionRates = useAppSelector((state) => state.currency.rates);

  const fromCurrency = currencyCode.toLowerCase();
  const toCurrency = useAppSelector((state) => state.currency.currencyCode);

  useEffect(() => {
    const rate =
      conversionRates.reduce((acc: any, curr: any) => {
        if (acc) return acc;
        if (curr.id === fromCurrency.toLowerCase()) return curr;
        else return null;
      }, null) ?? [];

    const rates = rate?.rates ?? [];

    const rateTo = toCurrency === fromCurrency ? 1 : (rates[toCurrency] ?? 1);

    if (rateTo) {
      try {
        setFormattedCurrency(
          new Intl.NumberFormat(navigator.languages[0] ?? 'en-GB', {
            style: 'currency',
            currency: toCurrency.toUpperCase(),
          }).format(Math.ceil(price * rateTo))
        );
      } catch (e) {
        console.log(e);
        setFormattedCurrency(`${toCurrency}${price * rateTo}`);
      }
    }
  }, [fromCurrency, price, conversionRates, toCurrency]);

  return priceOnRequest ? (
    <Typography sx={sx} variant={variant} data-cy={dataCy}>
      Price on request
    </Typography>
  ) : formattedCurrency ? (
    <Typography
      sx={sx}
      variant={variant}
      data-cy={dataCy}
    >{`${props.preText ?? ''} ${formattedCurrency} ${postText}`}</Typography>
  ) : (
    <Skeleton variant="text" width={200} height={25} />
  );
};

export default FormatCurrency;
